import { lazy, Suspense } from "react";
import { useOutletContext } from "react-router-dom";
import { Bars3Icon } from "@heroicons/react/24/outline";
import { useAiFeatures, usePortalNotifications } from "@flags";
import CollectedToday from "@areas/tasks/components/CollectedToday";

// Loaded lazily so PageHeader (a low-level @components module) doesn't statically import the bell,
// which pulls the @components barrel + drawer contexts back to PageHeader — a cycle that breaks
// module init order. The dynamic import keeps the graph acyclic.
const NotificationBell = lazy(() => import("../../portal-template/components/NotificationBell"));

const PageHeader = ({ children, actions }) => {
  const { openMenu } = useOutletContext();
  // The live "collected" figure rides the header on every page, AI-gated like the rest of the
  // intelligence surface.
  const showCollected = useAiFeatures();
  const notificationsEnabled = usePortalNotifications();

  return (
    <div className="flex-none flex h-12 shrink-0 items-center gap-x-4 border-b border-zinc-200 bg-white px-5 sm:gap-x-6">
      <button
        type="button"
        onClick={openMenu}
        className="-m-2.5 p-2.5 text-zinc-700 lg:hidden"
      >
        <span className="sr-only">Open sidebar</span>
        <Bars3Icon aria-hidden="true" className="size-6" />
      </button>

      {/* Separator */}
      <div aria-hidden="true" className="h-6 w-px bg-zinc-200 lg:hidden" />

      <div className="flex flex-1 items-center gap-x-4 self-stretch">
        {children}
        <div className="ml-auto flex shrink-0 items-center gap-x-3">
          {showCollected && <CollectedToday />}
          {showCollected && notificationsEnabled && (
            <div aria-hidden="true" className="h-6 w-px bg-zinc-200" />
          )}
          {notificationsEnabled && (
            <Suspense fallback={null}>
              <NotificationBell />
            </Suspense>
          )}
          {actions && <div aria-hidden="true" className="h-6 w-px bg-zinc-200" />}
          {actions}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
